/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

export type Category = {
  primaryId: string;
  chefId: any;
  name?: string;
  typeId?: string;
  amount?: number;
  enableDisableStatus: any;
  createdBy: any;
  updatedBy: any;
  message?: string;
  status?: string;
};
export const initialValues: Category = {
  primaryId:"",
  name: "",
  chefId: "",
  typeId: "",
  amount:0,
  enableDisableStatus: "",
  createdBy: 0,
  updatedBy: 0,
};
